module.exports = __webpack_public_path__ + "static/media/placeholder-4.407acf14.jpg";